"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var hydrationHelpers_1 = require("Public/Widgets/hydrationHelpers");
var hydrateComponents = function () {
    (0, hydrationHelpers_1.hydrate)(document.body, "[data-hydration-host]:not([mount-widgets] [data-hydration-host])");
};
hydrateComponents();
